/* eslint-disable no-unused-vars */
import { Container } from "@material-ui/core";
import React from "react";
import { globalColors } from "../../../../../_metronic/_assets/sass/custom/globalColors";
import { isXavierThemeV2Enabled } from "../../../../utils/FeatureFlags";

export const PageHeader = (props) => {
  const usePremiumIcon = isXavierThemeV2Enabled() && props.icon;

  return (
    <Container
      className={`xv-page-card-heading ${props.className || ""}`.trim()}
      style={{
        marginTop: "24px",
        minHeight: "48px",
        backgroundColor: `rgba(225, 222, 219, 0.25)`,
        display: "flex",
        alignItems: "center",
        padding: "0 1rem",
        width: "100%",
        maxWidth: "100% !important",
        borderRadius: "4px",
      }}
    >
      {usePremiumIcon ? (
        <span
          className="xv-page-card-heading__icon"
          role="img"
          aria-label={props.title}
          style={{
            WebkitMaskImage: `url(${props.icon})`,
            maskImage: `url(${props.icon})`,
          }}
        />
      ) : (
        <img
          src={props.icon}
          style={{
            width: "23px",
          }}
          alt={props.title}
        />
      )}
      <span
        className="xv-page-card-heading__title"
        style={{
          marginLeft: "10px",
          borderRadius: "4px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "600",
          fontSize: "18px",
          lineHeight: "150%",
          color: globalColors.primaryColor5,
        }}
      >
        {props.title}
      </span>
    </Container>
  );
};
